import { CommonResponse, PlantIdRequest } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { AssetByDate } from "../asset-assignment/dto/asset-by-date.dto";
import { AssetTransfersDto } from "./dto/asset-transfers.dto";
import { AssetTransfersService } from "./asset-transfers.service.ts";
import { TransferIdRequest } from "./dto/transfer-id.request";
import { LocationByPlant } from "../locations/dto/location-by-plant.dto";

@Controller('asset-transfers')
@ApiTags('asset-transfers')
export class AssetTransfersController {
    constructor(
        private assetTransfersService: AssetTransfersService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) {}

    
    @Post('/createAssetTransfers')
    async createAssetTransfers(@Body() createDto:AssetTransfersDto): Promise<CommonResponse> {
        try {
            return await this.assetTransfersService.createAssetTransfers(createDto);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getDCTransfers')
    async getDCTransfers(@Body() req: LocationByPlant): Promise<CommonResponse> {
        try {
            return await this.assetTransfersService.getDCTransfers(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getMRNTransfers')
    async getMRNTransfers(@Body() req: PlantIdRequest): Promise<CommonResponse> {
        try {
            return await this.assetTransfersService.getMRNTransfers(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }

    @Post('/ReceiveAsset')
    async ReceiveAsset(@Body() req: TransferIdRequest): Promise<CommonResponse> {
        try {
            return await this.assetTransfersService.ReceiveAsset(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getTransferDetails')
    async getTransferDetails(@Body() req: TransferIdRequest): Promise<CommonResponse> {
        try {
            return await this.assetTransfersService.getTransferDetails(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponse, err);
        }
    }
    
}